<template>
  <!--菜单-->
  <div class="menu-container">
    <template v-for="item in menuList">
      <el-submenu
        :index="item.name"
        v-if="item.children && item.children.length > 0"
        :key="item.name"
      >
        <template slot="title">
          <i
            class='iconfont'
            :class='item.meta.icon'
						:style="{background: `url(require('../../public/images/index/${item.meta.icon}.png')) no-repeat center/cover`}"
          ></i>
          <span>{{ item.meta.name }}</span>
        </template>
        <el-menu-item-group>
          <my-nav :menuList="item.children"></my-nav>
        </el-menu-item-group>
      </el-submenu>
      <el-menu-item
        :key="item.name"
        :index="item.name"
        @click="gotoRoute(item)"
        v-else
      >
        <span slot="title">{{ item.meta.name }}</span>
      </el-menu-item>
    </template>
  </div>
</template>

<script>
import { gotoRoute } from "@/utils/utilsRouter.js"
export default {
  name: "my-nav",
  props: {
    menuList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
	computed: {
		editableTabs:{
			get() {
				return this.$store.state.editableTabs;
			},
			set(val){
				this.$store.state.editableTabs = val;
			}
		},
  },
  methods: {
    gotoRoute(value) {
			gotoRoute(value)
    },
  },
};
</script>

<style lang='scss'>
.menu-container {
  .svg-icon {
    margin-right: 10px;
  }
}
.iconfont {
	display: inline-block;
	width: 15px;
	height: 15px;
	margin-right: 10px;
}
.customers {
	background: url('../../../public/images/index/customerManagement.png') no-repeat center/cover;
}
.basicSets {
	background: url('../../../public/images/index/basicSets.png') no-repeat center/cover;
}
.products {
	background: url('../../../public/images/index/productManagement.png') no-repeat center/cover;
}
.warehouse {
	background: url('../../../public/images/index/warehouseManagement.png') no-repeat center/cover;
}
.outAndIn {
	background: url('../../../public/images/index/inAndOutManagement.png') no-repeat center/cover;
}
.systemParam {
	background: url('../../../public/images/index/systemParamManagement.png') no-repeat center/cover;
}
.erp {
	background: url('../../../public/images/index/systemParamManagement.png') no-repeat center/cover;
}
</style>
